import { AnchoredSheet } from '@shared/components/AnchoredSheet';
import { getAnchorName } from '@shared/styles';
import { API } from '@shared/types/api';
import { useBoolean } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';
import { ReactionList } from './ReactionList';
import { ReactionRow } from './ReactionRow';
import styles from './ReactionRowWithReactionList.module.css';

interface ReactionRowWithReactionListProps {
  messageId: number;
  reactions: API.ReactionFragment[];
  align: 'left' | 'right';
  selected: API.ReactionType[];
  onToggleReaction: (reaction: API.ReactionType, add: boolean) => void;
}

export function ReactionRowWithReactionList({
  messageId,
  reactions,
  ...rest
}: ReactionRowWithReactionListProps) {
  const [isListVisible, showList, hideList] = useBoolean(false);
  const anchorName = getAnchorName('reactions', messageId);

  return (
    <>
      <ReactionRow
        messageId={messageId}
        reactions={reactions}
        anchorName={anchorName}
        onClickReaction={showList}
        {...rest}
      />

      {isListVisible && (
        <AnchoredSheet
          anchorName={anchorName}
          onClose={hideList}
          initialSize="half"
          className={styles.reactionsListSheet}
          title={i18n('common.reactions')}
        >
          <ReactionList reactions={reactions} />
        </AnchoredSheet>
      )}
    </>
  );
}
